import { request, type ApiResponse } from './client';

/**
 * Requests a fresh verification email for the authenticated user. Server
 * enforces a 60s rate limit; on 429 the response code is RATE_LIMITED with
 * a retryAfterSeconds field in the body. The modal that calls this
 * extracts retryAfterSeconds from the raw response body via the
 * details-style escape hatch (see EmailNotVerifiedModal).
 */
export function resendVerificationEmail(): Promise<ApiResponse<{ ok: true }>> {
  return request<{ ok: true }>('/auth/resend-verification-email', { method: 'POST' });
}
